export enum ProductConfigurationTypeEnum {
  COLOR = 'color',
  TEXT = 'text',
}